import cn from "@/v2-ui/utils/utils.cn"
import Tabs from "@/v2-backoffice-client/components/tabs"
import Page, { type PageProps } from "@/v2-backoffice-client/components/page"
import Embed from "@/v2-backoffice-client/components/embed"
import { ANALYTICS_DASHBOARDS } from "@/v2-backoffice-client/analytics/analytics.constants"

export type AnalyticsPageProps = PageProps

function AnalyticsPage(props: AnalyticsPageProps) {
  const { className, ...pageProps } = props

  return (
    <Page className={cn("analytics-page", className)} {...pageProps}>
      <Page.Header>
        <Page.Title>Analytics</Page.Title>
      </Page.Header>

      <Tabs
        id="analytics"
        defaultValue={ANALYTICS_DASHBOARDS[0]?.id ?? "overview"}
        className="analytics-tabs"
      >
        <Tabs.List className="analytics-tabs-list">
          {ANALYTICS_DASHBOARDS.map((d) => (
            <Tabs.Trigger key={d.id} value={d.id}>
              {d.label}
            </Tabs.Trigger>
          ))}
        </Tabs.List>

        {ANALYTICS_DASHBOARDS.map((d) => (
          <Tabs.Content
            key={d.id}
            value={d.id}
            className="analytics-tab-content"
          >
            <Embed className="analytics-embed" url={d.url} />
          </Tabs.Content>
        ))}
      </Tabs>
    </Page>
  )
}

export default AnalyticsPage
